import { render, staticRenderFns } from "./WollastonPrismViz.vue?vue&type=template&id=01a33cf5&scoped=true"
import script from "./WollastonPrismViz.vue?vue&type=script&lang=js"
export * from "./WollastonPrismViz.vue?vue&type=script&lang=js"
import style0 from "./WollastonPrismViz.vue?vue&type=style&index=0&id=01a33cf5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a33cf5",
  null
  
)

export default component.exports